
























import { Component, Vue } from 'vue-property-decorator'
import ModuleWrapper from '@/components/common/ModuleWrapper.vue'
import DataIntegrationForm from '@/components/preProcessing/DataIntegrationForm.vue'
import ModuleIntroduction from '@/components/common/ModuleIntroduction.vue'
import { TaskDetail } from '@/types/Task'
import TaskStatusTips from '@/components/common/TaskStatusTips.vue'

@Component({
  components: {
    DataIntegrationForm,
    ModuleWrapper,
    TaskStatusTips,
    ModuleIntroduction
  }
})
export default class DataIntegration extends Vue {
  private showStatusTips: boolean = false
  private taskDetail!: TaskDetail
  /**
   * 表单提交
   * @param taskDetail 新添加的任务详情信息
   * @private
   */
  private formSubmitHandler (taskDetail: TaskDetail) {
    this.taskDetail = taskDetail
    this.showStatusTips = true
  }
}

